import React from 'react';

const SkeletonLoader = () => {
  return (
    <div className="dashboard-panel p-5 space-y-4 animate-pulse opacity-50">
      <div className="h-6 bg-graphite-700 w-1/3 rounded-sm" />
      <div className="h-48 bg-graphite-700 w-full rounded-sm" />
      <div className="space-y-2">
        <div className="h-4 bg-graphite-700 w-3/4 rounded-sm" />
        <div className="h-4 bg-graphite-700 w-1/2 rounded-sm" />
      </div>
      <div className="pt-4 flex justify-between">
        <div className="h-8 bg-graphite-700 w-24 rounded-sm" />
        <div className="h-8 bg-graphite-700 w-32 rounded-sm" />
      </div>
    </div>
  );
};

export default SkeletonLoader;